export const HEADERS_ALERTS = [
  { key: 'AlertID', label: 'ID' },
  { key: 'merchant.BussinesName', label: 'Merchant' },
  { key: 'PriorityName', label: 'Prioridad' },
  { key: 'StatusName', label: 'Estado' },
  { key: 'Description', label: 'Descripción' },
  { key: 'created_at', label: 'Fecha creación' },
  { key: 'Actions', label: 'Opciones' }
];